<!-- Main Content Area -->
  <div class="capture-container" [class.compact-capture]="isCompactCapture">
  <div class="main-content">
    <div *ngIf="isBusy"><h2>{{ busyMessage }}</h2></div>

    <div class="mode-toggle" role="tablist" aria-label="Capture method">
      <button
        type="button"
        class="mode-toggle-btn"
        [class.active]="captureMode === 'record'"
        [disabled]="isBusy || isRecording"
        (click)="setCaptureMode('record')">
        Record
      </button>
      <button
        type="button"
        class="mode-toggle-btn"
        [class.active]="captureMode === 'upload'"
        [disabled]="isBusy || isRecording"
        (click)="setCaptureMode('upload')">
        Upload
      </button>
    </div>

    <div class="video-container" [hidden]="captureMode !== 'record'">
      <div class="video-wrapper face-on-wrapper">
        <div class="video-controls">
          <label class="video-label">Face-On Camera</label>
          <select 
            class="video-select" 
            [(ngModel)]="selectedFaceOnCamera"
            (change)="selectFaceOnCamera()">
            <option value="">Select Camera</option>
            <option *ngFor="let camera of availableCameras" [value]="camera.value">
              {{camera.label}}
            </option>
          </select>
        </div>
        <div class="video-content">
          <video #faceOnVideo autoplay playsinline muted webkit-playsinline>
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      <div class="video-wrapper dtl-wrapper">
        <div class="video-controls">
          <label class="video-label">{{ isCompactCapture ? 'Phone Camera (Down the Line)' : 'Down-The-Line Camera' }}</label>
          <select 
            class="video-select" 
            [(ngModel)]="selectedDownTheLineCamera"
            (change)="selectDownTheLineCamera()">
            <option value="">Select Camera</option>
            <option *ngIf="isCompactCapture" value="phone-rear">Rear camera</option>
            <option *ngFor="let camera of availableCameras" [value]="camera.value">
              {{camera.label}}
            </option>
          </select>
        </div>
        <div class="video-content">
          <video #downTheLineVideo autoplay playsinline muted webkit-playsinline>
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>

    <div class="upload-panel" *ngIf="captureMode === 'upload'">
      <div class="upload-angle" role="radiogroup" aria-label="Camera angle">
        <span class="video-label">Camera angle</span>
        <div class="mode-toggle">
          <button
            type="button"
            class="mode-toggle-btn"
            [class.active]="uploadCamera === 'face-on'"
            (click)="uploadCamera = 'face-on'">
            Face On
          </button>
          <button
            type="button"
            class="mode-toggle-btn"
            [class.active]="uploadCamera === 'down-the-line'"
            (click)="uploadCamera = 'down-the-line'">
            Down the Line
          </button>
        </div>
      </div>

      <label class="btn choose-video-btn">
        Choose video
        <input
          type="file"
          accept="video/*,.mov,.mp4,.m4v"
          (change)="onUploadFileSelected($event)">
      </label>
      <p class="upload-hint" *ngIf="uploadFile">{{ uploadFile.name }}</p>
      <p class="upload-hint" *ngIf="!uploadFile">Pick a clip from your camera roll. It will be converted to MP4.</p>

      <div class="upload-preview" *ngIf="uploadPreviewUrl">
        <video [src]="uploadPreviewUrl" controls playsinline webkit-playsinline></video>
      </div>
    </div>
    
    <!-- Control Bar -->
    <div class="control-bar">
      <button class="btn" (click)="backButtonClicked()">
        &lt; Back to Session
      </button>
      <button 
        *ngIf="captureMode === 'record'"
        class="record-btn" 
        [class.recording]="isRecording"
        (click)="toggleRecording()">
        <div class="record-icon"></div>
      </button>
      <button
        *ngIf="captureMode === 'upload'"
        class="btn"
        [disabled]="!uploadFile || isBusy"
        (click)="saveUploadedSwing()">
        Save swing
      </button>
      
      <div class="control-options" *ngIf="captureMode === 'record'">
        <div class="control-group">
          <label class="control-label">Record Delay</label>
          <select 
            class="control-select" 
            [(ngModel)]="recordDelay"
            (change)="updateRecordDelay()">
            <option value="0">0 second</option>
            <option value="8">8 seconds</option>
            <option value="15">15 seconds</option>
            <option value="30">30 seconds</option>
          </select>
        </div>
        
        <div class="control-group">
          <label class="control-label">Auto Stop After</label>
          <select 
            class="control-select" 
            [(ngModel)]="autoStopAfter"
            (change)="updateAutoStop()">
            <option value="5">5 seconds</option>
            <option value="8">8 seconds</option>
            <option value="15">15 seconds</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  </div>
